import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { app_perm_set_line_RowClass } from 'blg-akaun-ts-lib';
import { PermissionSetModel, PermSetLine, PermSetModel, RoleModel, UserModel } from '../../../../models/user-permissions.model';

export interface UserPermState extends EntityState<UserModel> {
    currentUser: UserModel;
    selectedUser: UserModel;
    updateUserListing: boolean;
    updatePermSetListing: boolean;
    selectedRole: RoleModel;
    selectedPermSet: PermSetModel;
    selectedPermSetLine: app_perm_set_line_RowClass;
    newPermSet: PermissionSetModel,
    selectedPermTemplate: any,
    selectedCreatedPermSet: PermissionSetModel,
    selectedCreatedPermSetLine: PermSetLine,
    selectedGuid: string;
    errorLog: {timeStamp: Date, log: string}[];
    totalRecords: number,
    requiresUpdate: boolean;
}

export const userPermAdapters: EntityAdapter<UserModel> = createEntityAdapter<UserModel>({
    selectId: a => a.bl_applet_login_subject_link.guid.toString()
});

export const initialState: UserPermState = userPermAdapters.getInitialState({
    currentUser: null,
    selectedUser: null,
    updateUserListing: false,
    updatePermSetListing: false,
    selectedRole: null,
    selectedPermSet: null,
    selectedPermSetLine: null,
    newPermSet: null,
    selectedPermTemplate: null,
    selectedCreatedPermSet: null,
    selectedCreatedPermSetLine: null,
    selectedGuid: null,
    errorLog: [],
    totalRecords: 0,
    requiresUpdate: false
})
